module.exports = __webpack_public_path__ + "7f67b2ae4e3db5b5121914c3c97e38c9.pdf";